import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import classes from './PromocodeButton.module.scss';
import Button from '@components/shared/Button/Button';
import { PercentIcon, SquarePercentIcon } from '@icons';
import { useTypedDispatch } from '@hooks/useTypedDispatch';
import { useSelector } from 'react-redux';
import { isPromocodeSelector, promocodeExpirationDateSelector } from '@store/models/subscription/selectors';
import { formatDate } from '@utils/date';
import { promoCodeButtonText } from '@configs/promocode';
import classNames from 'classnames';
import { InfoSquareIcon } from '@icons';
import { useWindowSize } from '@hooks/useWindowSize';
import Tooltip from '@components/shared/Tooltip/Tooltip';
import { useNavigate } from 'react-router';
import { Page } from '@const';
import { triggerMetricsEvent } from '@metrics';
const buttonConfig = {
    active: {
        variant: 'violet',
        text: 'Применён промокод',
        icon: _jsx(InfoSquareIcon, { containerClasses: classes.infoIcon }),
    },
    notActive: {
        variant: 'white',
        text: promoCodeButtonText,
        icon: _jsx(PercentIcon, {}),
    },
};
const desktopActivePromoButtonConfig = {
    variant: 'transparent',
    text: '',
    icon: _jsx(SquarePercentIcon, {}),
};
const PromocodeButton = ({ disabled, className }) => {
    const isPromoCode = useSelector(isPromocodeSelector);
    const promocodeExpirationDate = useSelector(promocodeExpirationDateSelector);
    const navigate = useNavigate();
    const { isDesktop } = useWindowSize();
    const { promocodeModel: { setPreviousPage }, } = useTypedDispatch();
    const expireDate = formatDate({
        date: promocodeExpirationDate || '',
        dateFormat: 'DD.MM.YYYY',
    });
    const promoTooltipText = (_jsxs(_Fragment, { children: ["\u041F\u0440\u0438\u043C\u0435\u043D\u0451\u043D \u043F\u0440\u043E\u043C\u043E\u043A\u043E\u0434 ", _jsx("br", {}), "\u0414\u0435\u0439\u0441\u0442\u0432\u0443\u0435\u0442 \u0434\u043E ", expireDate] }));
    const handlePromocodeClick = () => {
        if (!isPromoCode) {
            setPreviousPage(Page.Main);
            navigate(Page.Promocode);
            triggerMetricsEvent({ element: 'subscriptionBannerPromocodeButton' });
        }
    };
    const tooltipPosition = isDesktop ? 'bottom' : 'top';
    const { variant, icon, text } = !isPromoCode ? buttonConfig.notActive : isDesktop ? desktopActivePromoButtonConfig : buttonConfig.active;
    const button = (_jsx(Button, { className: classNames(classes.promocodeButton, className), text: text, size: "sm", variant: variant, icon: icon, full: !isDesktop, onClick: handlePromocodeClick, disabled: disabled }));
    return (_jsx(_Fragment, { children: isPromoCode ? (_jsx(Tooltip, { text: promoTooltipText, position: tooltipPosition, children: button })) : (button) }));
};
export default PromocodeButton;
